import { onClickOutside } from '../helpers/on-click-outside-inside';

const searchForm = document.getElementById('searchForm');
const searchFormTrigger = document.getElementById('searchFormTrigger');
const searchFormWrapper = document.querySelector('#searchFormWrapper');
const navMenuList = document.querySelector('.navMenu__list');

if (searchForm) {
    searchFormTrigger.addEventListener('click', () => {
        searchForm.classList.toggle('is-visible');
        navMenuList.classList.toggle('is-almost-hidden');
    });

    onClickOutside(searchFormWrapper, () => {
        searchForm.classList.remove('is-visible');
        navMenuList.classList.remove('is-almost-hidden');
    });
}
